import React, { useContext } from 'react';

import { AddReminder } from '../../../shared/AddReminder/AddReminder';
import { CompaignFilledContext } from '../../context/CompaignFilled';

interface ActionsProps {
	isCommunicationsEmpty?: boolean;
	setCommunication: (e: any) => void;
	onChangeToResults: () => void;
}

export const Actions = ({
	isCommunicationsEmpty,
	setCommunication,
	onChangeToResults,
}: ActionsProps): JSX.Element => {
	const { isEndedCampaign } = useContext(CompaignFilledContext);

	if (!isEndedCampaign) {
		return (
			<AddReminder
				disabled={isCommunicationsEmpty}
				buttonText="+ Agregar recordatorio"
				text="Envía un mensaje a los colaboradores que aún no responden la
								evaluación"
				onConfirm={() => setCommunication(true)}
			/>
		);
	}

	return (
		<AddReminder
			buttonText="Consultar resultados"
			text="La evaluación se ha cerrado, consulta los resultados"
			onConfirm={onChangeToResults}
		/>
	);
};
